module.exports = __webpack_public_path__ + "static/media/marker.945b8051.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Showcase/marker.svg
// module id = 597
// module chunks = 0